import Login from "@js/vue/pages/login/Login";

new Vue({
	el: '#login-vue',
	name: 'LoginVue',
	components: {
		'form-login': Login,
	},
	data(){
		return {
			logo: '',
			reCAPTCHA_site_key: '',
			isDev: true,
			isProduction: false,
			logoLogin: ''
		}
	},
	mounted() {
		this.initializeVariable()
	},
	methods: {
		initializeVariable(){
			const el = document.getElementById('data-page')
			if (el) {
				let value = el.value

				if (value) {
					Object.assign(this.$data, JSON.parse(value))
				}
			}
		},
	}
})

let isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
let href;
let storeApp;
let userAgent = navigator.userAgent;

if(! isChrome) {
	if(userAgent.toLowerCase().indexOf("android") > -1){
		href = 'https://play.google.com/store/apps/details?id=com.android.chrome';
		storeApp = "Google Play Store"
	}

	if(userAgent.toLowerCase().indexOf("iphone") > -1){
		href = 'https://apps.apple.com/us/app/google-chrome/id535886823';
		storeApp = "App Store"
	}

	if (! href) {
		href = "https://www.google.com/chrome/"
		storeApp = "Download Google Chrome versão desktop"
	}

	Swal.fire({
		type: 'info',
		title: 'Oops...',
		text: 'Para uma melhor experiência na aplicação, sugerimos que aceda através do Browser Google Chrome!',
		position: 'center',
		showConfirmButton: true,
		timer: 20000000,
		footer: `<a href="${href}" target="_blank">${storeApp} <i class="fa fa-external-link-alt"></i></a>`
	})
}
